import React, { useEffect, useState } from "react";
import style from "css/device.module.css";

function Consult(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={style.device_consult_wrap} style={{ marginTop: props.page === "allPlace" ? "0px" : "45px" }}>
      <img
        src={
          `${process.env.REACT_APP_CLIENT_URL}img/device/neat/consult_background${isMobile ? "_m" : ""}.webp`
        }
        alt="consult_background"
      />
      <div className={style.device_consult_contents_wrap}>
        <div className={style.device_consult_text_wrap}>
          <div className={style.device_consult_title}>상담 문의</div>
          <div className={style.device_consult_text}>
            상담 문의를 통해 필요한 정보와 맞춤형 제안을 받아보세요.
            {isMobile ? " " : <br />}
            저희 전문가 팀이 신속하고 정확한 답변을 드리겠습니다.
          </div>
        </div>
        {/* <div className={style.device_consult_btn_group}>
          <button className={style.device_consult_btn}>
            <span className={style.device_consult_btn_text}>상담 문의하기</span>
            <img
              className={style.device_consult_btn_arrow}
              src={
                `${process.env.REACT_APP_CLIENT_URL}img/common/right${isMobile ? "_white_m" : ""}.webp`
              }
              alt="right"
            />
          </button>
          <button className={style.device_consult_btn}>
            <span className={style.device_consult_btn_text}>
              제휴/제안 문의하기
            </span>
            <img
              className={style.device_consult_btn_arrow}
              src={
                `${process.env.REACT_APP_CLIENT_URL}img/common/right${isMobile ? "_white_m" : ""}.webp`
              }
              alt="right"
            />
          </button>
        </div> */}
        <div className={style.device_consult_contact_text_wrap}>
          Tel. <span>070-7798-1311</span><br />
          E-mail. <span>support@riv-tech.co.kr</span>
        </div>
      </div>
    </div>
  );
}

export default Consult;
